import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import LanguageIcon from "@mui/icons-material/Language";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import { Box, Grid, Typography } from "@mui/material";
import React, { memo } from "react";
import styles from "../../Rastreabilidade.module.css";

const iconStyle = {
	height: "45px",
	width: "45px",
	color: "#009199",
};

const linkDoWhatsapp = (numero) =>
	String(numero).startsWith("http")
		? numero
		: `https://wa.me/${String(numero).replace(/\D/g, "")}`;

/**
 * Espelha o AboutOrigin do campo: foto à esquerda, quem é a empresa à direita.
 *
 * O campo é MUI v5 e usa `<Grid item xs>`; aqui é v7, onde a prop virou
 * `size={{...}}` — copiar a marcação de lá sem traduzir faz os filhos ignorarem
 * a largura e se amontoarem numa linha só.
 */
function SobreDistribuidora({ distribuidora }) {
	const redes = distribuidora?.redes ?? {};
	const cidadeUf = [distribuidora?.cidade, distribuidora?.uf]
		.filter(Boolean)
		.join(", ");

	return (
		<Box component="main" sx={{ width: "100%", minHeight: "80vh", m: 0 }}>
			<Grid
				container
				sx={{
					display: "flex",
					justifyContent: "center",
					alignItems: "center",
					minHeight: "80vh",
				}}
			>
				<Grid
					size={{ xs: 12, md: 6 }}
					sx={{
						display: "flex",
						justifyContent: "center",
						alignItems: "center",
						px: { xs: 2, sm: 4 },
						py: 4,
					}}
				>
					<Box sx={{ textAlign: "center", width: "100%", maxWidth: "380px" }}>
						{distribuidora?.foto && (
							<img
								src={distribuidora.foto}
								className={styles.imgProdutor}
								alt={distribuidora?.nome ?? ""}
							/>
						)}
						<div className={styles.containerDescricao}>
							<p>
								<b>{distribuidora?.nome}</b>
							</p>
							<p>{cidadeUf}</p>
							{redes.whatsapp && (
								<a
									href={linkDoWhatsapp(redes.whatsapp)}
									target="_blank"
									rel="noreferrer"
									className={styles.linkAboutOrigin}
								>
									<button className={styles.buttonAboutOrigin}>
										Fale com a distribuidora
									</button>
								</a>
							)}
						</div>
					</Box>
				</Grid>

				<Grid
					size={{ xs: 12, md: 6 }}
					sx={{
						display: "flex",
						flexDirection: "column",
						justifyContent: "center",
						py: 5,
						px: { xs: 3, sm: 8 },
						minHeight: { md: "80vh" },
					}}
				>
					<Box sx={{ mb: "20px" }}>
						<Typography variant="body1" sx={{ fontWeight: "600" }}>
							Sobre a origem
						</Typography>
						<Typography
							variant="h3"
							sx={{
								fontWeight: "700",
								color: "#009199",
								fontSize: "clamp(2rem, 1.25rem + 3vw, 3rem)",
								wordBreak: "break-word",
							}}
						>
							{distribuidora?.nome}
						</Typography>
					</Box>

					{distribuidora?.descricao && (
						<Typography variant="body1" sx={{ mb: "25px", wordBreak: "break-word" }}>
							{distribuidora.descricao}
						</Typography>
					)}

					<Box
						sx={{
							textAlign: "end",
							display: "flex",
							flexDirection: "column",
							alignItems: "end",
							mt: "auto",
						}}
					>
						<Typography variant="h5" sx={{ fontWeight: "600" }}>
							{cidadeUf}
						</Typography>

						<Box sx={{ display: "flex", gap: 2, mt: 2 }}>
							{redes.instagram && (
								<a href={redes.instagram} target="_blank" rel="noreferrer">
									<InstagramIcon sx={iconStyle} />
								</a>
							)}
							{redes.facebook && (
								<a href={redes.facebook} target="_blank" rel="noreferrer">
									<FacebookIcon sx={iconStyle} />
								</a>
							)}
							{redes.website && (
								<a href={redes.website} target="_blank" rel="noreferrer">
									<LanguageIcon sx={iconStyle} />
								</a>
							)}
							{redes.whatsapp && (
								<a
									href={linkDoWhatsapp(redes.whatsapp)}
									target="_blank"
									rel="noreferrer"
								>
									<WhatsAppIcon sx={iconStyle} />
								</a>
							)}
						</Box>
					</Box>
				</Grid>
			</Grid>
		</Box>
	);
}

export default memo(SobreDistribuidora);
